import { useLingui } from '@lingui/react/macro';

/**
 * Primary navigation links, shared by the Header (desktop) and the Mobile Menu
 * so both stay in sync. `t` is used in-scope here because it is a Lingui macro.
 */
/**
 * The mobile menu button: a brand-orange rounded square, per the mobile hand-off — it used to be a bare
 * icon on the page background.
 *
 * Shared because it is rendered twice: by the real drawer trigger, and by the `Suspense` fallback that
 * stands in until the drawer's lazy chunk arrives. Styling only one of them would make the button
 * change shape as the page finishes loading.
 */
export const MOBILE_MENU_BUTTON =
	'bg-brand text-ink cursor-pointer ml-auto grid size-12 shrink-0 place-items-center rounded-xl transition-colors hover:bg-brand-strong xl:hidden';

export function useNavLinks() {
	const { t } = useLingui();
	return [
		{ to: '/www/solutions', label: t`Solutions` },
		{ to: '/www/partner-ngos', label: t`Partner NGOs` },
		{ to: '/www/about-us', label: t`About Us` },
	] as const;
}
